import { WalletIcon } from '../../../assets/Icon';
import styles from './style.module.scss';

type WalletInfoCardProps = {
  title: string;
  amount: string;
  buttonText?: string;
  lastTransaction?: string;
  lastTransactionText: string;
  hideIcon?: boolean;
  className?: string;
  variant?: 'light' | 'dark';
  loading?: boolean;
  onButtonClick?: () => void;
};
const WalletInfoCard = ({
  amount,
  lastTransaction,
  title,
  buttonText,
  hideIcon,
  loading,
  lastTransactionText,
  className = '',
  variant = 'light',
  onButtonClick,
}: WalletInfoCardProps) => {
  return (
    <div
      className={`${styles.wrapper} ${!!buttonText && styles.withButton} ${className} ${styles[variant]}`}
    >
      {!hideIcon && (
        <div className={styles.walletIcon}>
          <WalletIcon size={40} color="var(--primary)" />
        </div>
      )}
      <div className="w-100">
        <div className={styles.balance}>
          <div>
            <h5 className={styles.label}>{title}</h5>
            <p className={styles.value}>{amount}</p>
          </div>
          {buttonText && (
            <button className={styles.actionButton} onClick={onButtonClick}>
              {buttonText}
            </button>
          )}
        </div>
        <div className={styles.transaction}>
          {lastTransactionText}
          {lastTransaction && (
            <>
              <p className="m-0">: {lastTransaction}</p>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default WalletInfoCard;
